import React, { useEffect, useState,useContext } from 'react'
// @mui material components
import Card from "@mui/material/Card";
import Tooltip from "@mui/material/Tooltip";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import AddFacilityTypeToSession from './AddFacilityTypeToSession';
import SessionFacilitiesTable from './SessionFacilitiesTable';
import { LanguageContext } from "App";
import AddFacilityTypeToSessionReq from "../../../../Classes/Models/Requests/AddManyToManyReq"
import RemoveReq from "../../../../Classes/Models/Requests/SearchStringOrIntReq"
import SessionsApi from '../../../../Classes/API/Administration/SessionsApi';
import Swal from 'sweetalert2';



const Index = ({ Session, setIsLoaded }) => {

  const {translations} = useContext(LanguageContext)
  const AddToSession = async (TypeId, Qty) => {
    let addReq = new AddFacilityTypeToSessionReq();

    addReq.Id1 = Session.id;
    addReq.Id2 = TypeId;
    addReq.QuantityNeeded = Qty;

    let res = await SessionsApi.AddFacilityTypeToSession(addReq);

    if (res.status == "Success") {

      console.log("inn")
      setIsLoaded(false);
    }
  }

  
  const RemoveFromSession = async (id) => {

    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.value) {
        let removeReq = new RemoveReq(); 
        removeReq.SearchInt = id; 
        let res = await SessionsApi.RemoveFacilityTypeFromSession(removeReq); 
        if (res.status == "Success") {
          setIsLoaded(false);
          Swal.fire(
            'Deleted!',
            'Deleted.',
            'success'
          )
        }
      }
    })



  }
  

  return (
    <div className="mb-3 col-md-12">
      <div className="card">
        <MDBox display="flex" justifyContent="space-between" alignItems="center" pt={2} px={2}>
          <MDTypography variant="h6" fontWeight="medium" textTransform="capitalize">
            {translations.sessionPgSessionsManageSessionFacilityTypes}
          </MDTypography>
        </MDBox>
        <MDBox p={2}>
          <AddFacilityTypeToSession AddToSession={AddToSession}
            setIsLoaded={setIsLoaded} Session={Session} />

          <SessionFacilitiesTable RemoveFromSession={RemoveFromSession} Session={Session} />
        </MDBox>
      </div>
    </div>
  )
}

export default Index